import MyFanDomItem from './MyFanDomItem';
import HorizontalScroll from './HorizontalScroll';
import useMyFamDomsQuery from '../hooks/useMyFamDomsQuery';
import MyFanDomItemSkeleton from './MyFanDomItemSkeleton';
import type { ArtistType } from '../../types/ArtistType';

const MyFanDomList = () => {
  //@TODO: isError일때 처리 방식 이야기 나눠보기
  const { data, isLoading } = useMyFamDomsQuery();

  if (isLoading) {
    return (
      <div className="-mr-[24px] -ml-[3px] pt-[12px]">
        <HorizontalScroll listClassName="flex gap-[14px]">
          {[1, 2, 3].map((idx) => (
            <MyFanDomItemSkeleton key={idx} />
          ))}
        </HorizontalScroll>
      </div>
    );
  }

  return (
    <div className="-mr-[24px] -ml-[24px]">
      <HorizontalScroll listClassName="first:ml-[9px] last:mr-[24px]">
        {data?.map((artist: ArtistType) => (
          <MyFanDomItem key={artist.artistId} artist={artist} />
        ))}
      </HorizontalScroll>
    </div>
  );
};

export default MyFanDomList;
